import { render, staticRenderFns } from "./WebAddress.vue?vue&type=template&id=4e9a2e54"
import script from "./WebAddress.vue?vue&type=script&lang=js"
export * from "./WebAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports